import type {Payment} from "../types";

export function mergePaymentSnapshots(current: Payment[], incoming: Payment[]): Payment[] {
    const known = new Map(current.map(item => [item.paymentId ?? item.orderId, item]));
    return incoming.map(item => {
        const previous = known.get(item.paymentId ?? item.orderId);
        if (!previous) return item;
        // Terms have their own revision: changing them need not update the
        // payment row's timestamp. Keep the whole consistent server snapshot.
        if ((previous.exchange?.terms?.revision ?? 0) > (item.exchange?.terms?.revision ?? 0)) return previous;
        if (Date.parse(previous.updatedAt) > Date.parse(item.updatedAt)) return previous;
        if ((previous.status === "success" || previous.status === "cancelled") &&
            (item.status === "pending" || item.status === "new")) return previous;
        // Подтверждённая доставка не откатывается устаревшим снимком, но только
        // своя: свежая отмена после подтверждённого завершения — другая команда.
        const sameAction = !item.externalCompletion ||
            (item.externalCompletion.action ?? "completed") === (previous.externalCompletion?.action ?? "completed");
        if (previous.externalCompletion?.state === "confirmed" && item.externalCompletion?.state !== "confirmed" && sameAction) return {...item, externalCompletion: previous.externalCompletion};
        if (previous.exchange?.payoutStatus === "confirmed" && item.exchange?.payoutStatus !== "confirmed") return previous;
        return item;
    });
}
